const ossatureMetallique = [
  {
    id: "corniere-ossature",
    title: "Cornière",
    image: "/assets/images/products/Cornière Ossature_metallique.webp",
    specImage: "Cornière Ossature_metallique.webp",
    description: "Profilé d'angle pour finitions et renforts",
    longDescription: "Les cornières d'ossature métallique sont des profilés en L utilisés pour les finitions d'angles, les jonctions entre plafonds et murs, et le renforcement des arêtes dans les systèmes de construction sèche. Elles assurent une finition soignée et renforcée des angles, facilitant la pose des enduits et peintures de finition.",
    category: "ossature_metallique",
    specifications: [
      "Dimensions: 23x23mm, 30x30mm ou 50x50mm",
      "Épaisseur: 0.5 à 0.6mm",
      "Acier galvanisé Z140",
      "Longueurs standard: 3m",
      "Types: perforées ou pleines selon application"
    ]
  },
  {
    id: "fourrure",
    title: "Fourrure",
    image: "/assets/images/products/Fourrure.webp",
    specImage: "Fourrure.webp",
    description: "Profilé pour plafonds suspendus et doublages",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de profilés spéciaux.",
    category: "ossature_metallique",
    specifications: [
      "Aucune spécification technique fournie",
      "Fabrication selon normes en vigueur",
      "Matériau durable et robuste",
      "Finition professionnelle",
      "Installation par des professionnels qualifiés recommandée"
    ]
  },
  {
    id: "montant",
    title: "Montant",
    image: "/assets/images/products/Montant.webp",
    specImage: "Montant.webp",
    description: "Profilé vertical pour cloisons et doublages",
    longDescription: "Ossature métallique verticale en acier galvanisé, disposant d'une protection contre la corrosion conforme à la norme NF EN 14195. Profilé destiné à la réalisation de la structure portante des cloisons.",
    category: "ossature_metallique",
    specifications: [
      "Dimensions standardisées selon normes industrielles",
      "Réaction au feu: Euroclasse A1 (non combustible)",
      "Protection contre la corrosion conforme à la norme NF EN 14195",
      "Facilité d'installation et de fixation",
      "Perforations pour passage de gaines"
    ]
  },
  {
    id: "rail",
    title: "Rail",
    image: "/assets/images/products/Rail.webp",
    specImage: "Rail.webp",
    description: "Profilé horizontal pour guidage des montants",
    longDescription: "Ossature métallique verticale en acier galvanisé, disposant d'une protection contre la corrosion conforme à la norme NF EN 14195. Profilé en forme de « C » destiné à la réalisation de la structure portante des cloisons. Réaction au feu: Euroclasse A1 (non combustible).",
    category: "ossature_metallique",
    specifications: [
      "Tableau des spécificités fourni pour les modèles 48/30, 70/30, 90/30, etc.",
      "Réaction au feu: Euroclasse A1 (non combustible)",
      "Protection contre la corrosion conforme à la norme NF EN 14195",
      "Structure portante pour cloisons",
      "Installation professionnelle recommandée"
    ]
  },
  {
    id: "profiles-galvanise-placo",
    title: "Profilés galvanisé pour placo platre",
    image: "/5.webp",
    specImage: null,
    description: "Profilés galvanisés spécialement conçus pour les systèmes de placo plâtre",
    longDescription: "Les profilés galvanisés pour placo plâtre offrent une solution complète pour la réalisation d'ossatures métalliques. Fabriqués en acier galvanisé de haute qualité, ils garantissent une excellente résistance à la corrosion et une durabilité optimale. Ces profilés sont idéaux pour la construction de cloisons, faux plafonds et doublages, offrant une structure solide et fiable pour vos projets de construction sèche.",
    category: "ossature_metallique",
    specifications: [
      "Acier galvanisé haute qualité",
      "Protection contre la corrosion conforme aux normes",
      "Dimensions standardisées pour faciliter l'installation",
      "Compatible avec tous les systèmes de placo plâtre",
      "Réaction au feu: Euroclasse A1 (non combustible)",
      "Installation facile et rapide"
    ]
  }
];

export default ossatureMetallique;
